"use client";

import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";

import {cn} from "@/lib/utilities";

const Progress = React.forwardRef<
  React.ComponentRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({className, value, ...props}, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn("relative h-2 w-full overflow-hidden rounded-full bg-neutral-900/20 dark:bg-neutral-50/20", className)}
    {...props}>
    <ProgressPrimitive.Indicator
      className='h-full w-full flex-1 bg-neutral-900 transition-all dark:bg-neutral-50'
      style={{transform: `translateX(-${100 - (value || 0)}%)`}}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export {Progress};
